import { createMetricsFactory } from 'metrics-js';
const Metrics = createMetricsFactory('automation-ui-enrollment');
export default Metrics;